/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Create_TitleInputs */

const en_us2_clubs_create_title = /** @type {(inputs: Clubs_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New club`)
};

const pt_br2_clubs_create_title = /** @type {(inputs: Clubs_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo clube`)
};

const es_419_clubs_create_title = /** @type {(inputs: Clubs_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo club`)
};

const pt_pt2_clubs_create_title = /** @type {(inputs: Clubs_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo clube`)
};

const fr_fr2_clubs_create_title = /** @type {(inputs: Clubs_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau club`)
};

const de_de2_clubs_create_title = /** @type {(inputs: Clubs_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Club`)
};

const it_it2_clubs_create_title = /** @type {(inputs: Clubs_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo club`)
};

/**
* | output |
* | --- |
* | "New club" |
*
* @param {Clubs_Create_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_create_title = /** @type {((inputs?: Clubs_Create_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Create_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_create_title(inputs)
	if (locale === "es-419") return es_419_clubs_create_title(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_create_title(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_create_title(inputs)
	if (locale === "de-DE") return de_de2_clubs_create_title(inputs)
	if (locale === "it-IT") return it_it2_clubs_create_title(inputs)
	return en_us2_clubs_create_title(inputs)
});
export { clubs_create_title as "clubs.create_title" }